import { render, staticRenderFns } from "./SexSelect.vue?vue&type=template&id=4634a350&"
import script from "./SexSelect.vue?vue&type=script&lang=js&"
export * from "./SexSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports